class Microchart {
}

angular.module('eficienciaFiscalModule')
    .component('microchart', {
        controller: [Microchart],
        bindings: {
            label: '@',
            valor: '@',
            crescimento: '<',
            periodo: '<'
        },
        template: `
        <div class="microchart">
            <div class="valor-container">
                <span class="text-muted text-bold">{{$ctrl.label}}</span>
                <div>
                    <span class="valor">{{$ctrl.valor}}</span>
                </div>
            </div>
            <div class="porcento">
                <span 
                    ng-if="$ctrl.crescimento"
                    ng-class="{'text-success': $ctrl.crescimento >= 0, 'text-danger': $ctrl.crescimento < 0}">
                    {{$ctrl.crescimento >= 0 ? '+' : ''}}{{$ctrl.crescimento}}%
                </span>
                <span ng-if="!$ctrl.crescimento">
                    --
                </span>
                <div>
                    <span class="text-muted">Ref. {{$ctrl.periodo.inicio | date: 'dd/MM/yyyy'}} á {{$ctrl.periodo.fim | date: 'dd/MM/yyyy'}}</span>
                </div>
            </div>
        </div>
        `
    })